export enum EPeopleUrls {
  BASE = 'people',
  IDENTITY = 'identity',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  TITLE = 'title',
  EMAIL = 'email',
  PHONE = 'phone',
  ADDRESS = 'address',
  ADDITIONAL_EMAIL = 'additional-email',
  ADDITIONAL_PHONE = 'additional-phone',
  PEOPLE_ORGANIZATIONS = 'people-organizations',
  OWN_EMAIL = 'own-email',
  OWN_EMAIL_VALIDATE_OTP = 'own-email/validate-otp',
}
